const ENV_VAR = process.env.REACT_APP_DEV_ENV

let uri='';
console.log('enviro',ENV_VAR)

//  if(ENV_VAR == 'live_env')
//  { 

 //uri = 'https://beta-api.solminds.com/api'; // beta url

  uri = 'https://app-api.gisaschools.org/api'; 
   //uri = 'https://app-api-beta.gisaschools.org/api'; 

//uri = "https://d1hsa8xh8r26go.cloudfront.net/api"


//  }else if(ENV_VAR == 'local_env') 
//  { 
// uri = 'http://localhost:5000/api';

  
// }


const api = uri+"/";

export {api};

const loginurl = uri+"/users/login";

export {loginurl};

const GOOGLECLIENTID = "482930933906-gkejeqnf9m6pp0q2lintgsoog7398dt4.apps.googleusercontent.com";
export {GOOGLECLIENTID};

const validateotp = uri+"/users/validateotp";

export {validateotp};

const userurl = uri+"/users";

export {userurl};

const jobscategorycreate = uri+"/jobcategories";

export {jobscategorycreate}

const jobscategorycreatec = uri+"/jobcategories/";

export {jobscategorycreatec}

const sportlist =uri+"/sports"

export {sportlist}

const facultyposlists =uri+"/facultypositions"

export {facultyposlists}

const facultyposlistsc =uri+"/facultypositions/"

export {facultyposlistsc}

const accreditationurl = uri+"/accreditations";

export {accreditationurl}

const accreditationcurl = uri+"/accreditations/";

export {accreditationcurl}

const degreeurl = uri+"/degrees";

export {degreeurl}

const degreecurl = uri+"/degrees/";

export {degreecurl}

const faculty_categoryurl = uri+"/facultycategories";

export {faculty_categoryurl}

const faculty_categorycurl = uri+"/facultycategories/";

export {faculty_categorycurl}

const linksurl = uri+"/links";

export {linksurl}

const linkscurl = uri+"/links/";

export {linkscurl}

const foreignexchangelists = uri+"/foreignexchanges"

export {foreignexchangelists}

const schoolsurl = uri+"/schools"

export {schoolsurl}

const schoolsApiurl = uri+"/schools/listingapi"

export {schoolsApiurl}

const allschoolsListing = uri+"/schools/schoollist/allschoollisting"

export {allschoolsListing}

const allschools = uri+"/schools/schoollist/allschools"

export {allschools}

const allschoolsListingfilter = uri+"/schools/schoollist/schoolsfilter"

export {allschoolsListingfilter}

const schoolJobsurl = uri+"/jobs/school"

export {schoolJobsurl}

const schoolFacultyurl = uri+"/faculties/school"

export {schoolFacultyurl}

const countyurl = uri+"/counties/"

export {countyurl}

const regionurl = uri+"/regions/"

export {regionurl}

const association = uri+"/associations/"

export {association}

const schoolsedit = uri+"/schools/characteristics/"

export {schoolsedit}

const eligibility = uri+"/eligibilities/school/"

export {eligibility}

const associationurl = uri+"/associations/"

export {associationurl}

const officials = uri+"/officials"

export {officials}

const rules = uri+"/rules"

export {rules}

const associatiolistpublic = uri+'/associationsListPublic'

export {associatiolistpublic}
const rquestions = uri+"/rulequestion"

export {rquestions}
const officialtest = uri+"/officialtest/"

export {officialtest}
const mailsend = uri+'/mailsending'

export {mailsend}

const certify = uri+'/officialtest/certificate'

export {certify}

const gisa_association = uri+'/gisaassociation' 

export {gisa_association} 
const payAPI = uri+'/payment/accept'

export { payAPI }

const schoolPublicurl = uri+'/schoolPubliclist' 

export {schoolPublicurl}

const sportsPublicurl = uri+'/schoolPubliclist/sportsPubliclist' 

export {sportsPublicurl}

const officialspublicurl = uri+'/officialspublic'

export {officialspublicurl}

const paymentUrl = uri+'/payment'

export {paymentUrl}

const dashboardApproveUrl = uri+'/dashboard/hoapproved_data' 

export {dashboardApproveUrl}


const athletDashboardURL = uri+'/dashboard/athletDatas' 

export {athletDashboardURL}

const facultyDashboardURL = uri+'/dashboard/facultyDatas' 

export {facultyDashboardURL}

const permissionDashboardURL = uri+'/dashboard/permissionDatas' 

export {permissionDashboardURL}

const giaaPending = uri+'/dashboard/athletic/pendingByGiaa' 

export {giaaPending}

const newAthleticURL = uri+'/dashboard/athletic/newAE' 

export {newAthleticURL}

const updateAthleticURL = uri+'/dashboard/athletic/updateAE' 

export {updateAthleticURL}

const ineligibleAthleticURL = uri+'/dashboard/athletic/newIneligible' 

export {ineligibleAthleticURL}

const approvedAthleticURL = uri+'/dashboard/athletic/newApproved' 

export {approvedAthleticURL}

const facultyPosURL = uri+'/dashboard/athletic/lastFaculty' 

export {facultyPosURL}

const eventURL = uri+'/cm/event' 

export {eventURL}

const publicEventURL = uri+'/cm/public/event' 

export {publicEventURL}


const schoolPublicURL = uri+'/schoolPubliclist' 

export {schoolPublicURL}

const registerEventURL = uri+'/cm/register/event/' 

export {registerEventURL}

const attendeeEventURL = uri+'/cm/attendee/event/' 

export {attendeeEventURL}

const CheckSeminar = uri+'/cm/check/' 

export {CheckSeminar}

const CheckWorkshop = uri+'/workshop/check/' 

export {CheckWorkshop}

const registerViewURL = uri+'/cm/register/view/' 

export {registerViewURL}

const attendeeViewURL = uri+'/cm/attendee/view/' 

export {attendeeViewURL}

const attendeeRegisterURL = uri+'/cm/attendee/register/' 

export {attendeeRegisterURL}

const officialpayAPI = uri+'/officialpayment/accept'

export { officialpayAPI }

const officialAllURL = uri+'/officials/all/association/'

export { officialAllURL }

const attendeePaymentURL = uri+'/cmpayment/accept'

export { attendeePaymentURL }

const eventSeatsLeft = uri+'/cm/event/seats/'

export { eventSeatsLeft }

const paymentAssoPending = uri+'/dashboard/association/pending'

export { paymentAssoPending }

const paymentAssoPendingDet = uri+'/dashboard/association/officials'

export { paymentAssoPendingDet }

const associationNewOfficials = uri+'/dashboard/association/newofficials'

export { associationNewOfficials }

const FileUploadAthletURL = uri+'/athleticupload/upload'

export { FileUploadAthletURL }


const WorkshopListURL = uri+'/workshop/workshop'

export { WorkshopListURL }


const WorkshopPublicURL = uri+'/workshop/'

export { WorkshopPublicURL }


const WorkshopPaymentURL = uri+'/workshopPayment/accept'

export { WorkshopPaymentURL }

const AssociationWebsite = uri+'/joblist/association'

export { AssociationWebsite }


//table cost 
const TablecostAdd = uri+'/exhibition/table/create'

export { TablecostAdd }

const TablecostEdit = uri+'/exhibition/table/update/'

export { TablecostEdit }

const tablecostlistapi = uri+'/exhibition/table'

export { tablecostlistapi }

const Tablecostdelete = uri+'/exhibition/table/'

export { Tablecostdelete }

const Tablecost = uri+'/exhibition/table/'

export { Tablecost }

const Tablecostdroplist = uri+'/exhibition/tablelist'

export { Tablecostdroplist }

const tableElecostdroplist = uri+'/exhibition/electriciylist'

export { tableElecostdroplist }

//electricity

const EleccostAdd = uri+'/exhibition/electable/create'

export { EleccostAdd }

const EleccostEdit = uri+'/exhibition/electable/update/'

export { EleccostEdit }

const Eleccostlistapi = uri+'/exhibition/electable'

export { Eleccostlistapi }

const Eleccostdelete = uri+'/exhibition/electable/'

export { Eleccostdelete }

const Eleccost = uri+'/exhibition/electable/'

export { Eleccost }

//exhibition

const Exhibitionadd = uri+'/exhibition/create'

export { Exhibitionadd }

const exhibitionlist = uri+'/exhibition'

export { exhibitionlist }

const exhibitionupdate = uri+'/exhibition/update/'

export { exhibitionupdate }

const exhibitionview = uri+'/exhibition/view/'

export { exhibitionview }

const exhibitionPayment = uri+'/exhibitionpayment/accept'

export { exhibitionPayment }

const fileUpload = uri+'/fileupload'

export { fileUpload }

const mailSending = uri+'/users/mail'

export { mailSending }

const adminPermission = uri+'/adminpermissions'

export { adminPermission }


